const initializeBazaarVoice = () => {
    window.bvCallback = BV => {
        BV.swat_reviews.on("show", () => {
            window.dispatchEvent(new CustomEvent("reviews:showMobileMore"));

            const reviewsElement = document.getElementById(
                "productDetail.anchor.hash.reviews",
            );
            if (reviewsElement) {
                reviewsElement.scrollIntoView();
            }
        });
    };
};
export { initializeBazaarVoice };
